import React from 'react';

const Pagination = ({ count, page, pageSize, onChange }) => {
  const totalPages = Math.ceil(count / pageSize);
  if (totalPages <= 1) return null;

  const pages = [];
  for (let i = 1; i <= totalPages; i++) {
    if (i === 1 || i === totalPages || (i >= page - 1 && i <= page + 1)) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== '...') {
      pages.push('...');
    }
  }

  return (
    <div className="d-flex align-items-center justify-content-between mt-3 px-2">
      <small className="text-muted">
        Showing {((page - 1) * pageSize) + 1}–{Math.min(page * pageSize, count)} of {count}
      </small>
      <nav>
        <ul className="pagination pagination-sm mb-0">
          <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
            <button className="page-link" onClick={() => onChange(page - 1)}>‹</button>
          </li>
          {pages.map((p, i) => (
            <li key={i} className={`page-item ${p === page ? 'active' : ''} ${p === '...' ? 'disabled' : ''}`}>
              <button className="page-link" onClick={() => typeof p === 'number' && onChange(p)}>{p}</button>
            </li>
          ))}
          <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
            <button className="page-link" onClick={() => onChange(page + 1)}>›</button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;
